import * as types from "../types/segmentTypes";

const initialState = {
  isLoading: true,
  isError: null,
  data: {},
  segmentTypeEdit: { isOpen: false, segmentType: {} },
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.IS_LOADING:
      return { ...state, isLoading: payload };
    case types.IS_ERROR:
      return { ...state, isError: payload };
    case types.DATA:
      return { ...state, data: payload };
    case types.EDIT:
      return { ...state, segmentTypeEdit: payload };
    default:
      return state;
  }
}
